module.exports = __webpack_public_path__ + "media/npc_dota_hero_lion.462f9b9d.webm";